<template>
  <div id="scoreboard">
    <v-card
      class="mx-auto"
      max-width="344"
    >
      <v-card-title>
        <v-row no-gutters>
          <div>Best Scores</div>
          <v-spacer />
          <v-btn class="ml-4" icon @click="reveal = !reveal">
            <v-icon v-if="reveal">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      
      <v-expand-transition>
      <v-card
        v-if="reveal"
        class="transition-fast-in-fast-out"
        style="height: 100%;"
      >
        <v-card-text class="scores">
          <div v-for="(score, idx) in scores" :key="idx" class="score">
            <v-row no-gutters class="score-label">
              <v-icon v-if="idx < 3" class="mr-2" :color="starColors[idx]">mdi-star</v-icon>
              {{ score[0] }}
            </v-row>
            <span class="score-value">{{ score[1].toLocaleString('fr-FR') }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Scoreboard",
  data() {
    return {
      reveal: false,
    };
  },
  computed: {
    scores() {
      const s = [
        ['cali', 720201 ],
        ['mina', 411273 ],
        ['chex', 47805 ],
      ];
      s.sort((a, b) => a[1] > b[1] ? -1 : 1);
      return s;
    },
    starColors() {
      return ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-2'];
    },
  },
};
</script>

<style scoped>
#scoreboard {
  position: absolute;
  top: 30px;
  right: 10px;
  width: 20vw;
}

.scores {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 0rem;
}

.score {
  display: contents;
}

.score-label,
.score-value {
  padding: 4px;
}
.score-label {
  font-weight: bold;
  font-size: 1rem;
}
.score-value {
  text-align: right;
  font-size: 1.1rem;
}
</style>
